// useAutocompleteData.js
import { useEffect, useState } from 'react';

const useAutocompleteData = (url, params) => {
  const [data, setData] = useState([]);

  useEffect(() => {
    fetch(url, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(params),
    })
      .then((response) => {
        if (!response.ok) {
          throw new Error('Unable to read details properly..!');
        }
        return response.json();
      })
      .then((responseData) => {
        //setData(responseData);

          // Include an empty string in the data only if it's an array and doesn't already contain an empty string
          const updatedData = Array.isArray(responseData) && !responseData.includes('') ? [''].concat(responseData) : responseData;
          setData(updatedData);

          //console.log(updatedData);
      })
      .catch((error) => {
        console.error('Unable to read details properly..!');
      });
  }, [url, params]);

  return data;
};

export default useAutocompleteData;
